import { render, staticRenderFns } from "./DebtForm.vue?vue&type=template&id=76553052&"
import script from "./DebtForm.vue?vue&type=script&lang=js&"
export * from "./DebtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports